<template>
  <div class="app-admin-page">
    <div class="app-admin-card">
      <div class="toolbar">
        <div class="toolbar-left">
          <el-input
            v-model="keyword"
            placeholder="搜索邮箱、昵称、B站UID"
            clearable
            prefix-icon="el-icon-search"
            style="width: 260px"
            @keyup.enter.native="getUsers"
          />
          <el-button type="primary" icon="el-icon-search" @click="getUsers">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </div>
        <div class="toolbar-count">共 {{ list.length }} 位用户</div>
      </div>

      <el-table :data="list" height="76vh" border style="width: 100%">
        <el-table-column label="用户" min-width="220">
          <template slot-scope="scope">
            <div class="user-cell">
              <el-avatar :size="44" :src="scope.row.avatar || defaultAvatar"></el-avatar>
              <div class="user-info">
                <div class="nickname">{{ scope.row.nickname || "未设置昵称" }}</div>
                <div class="muted">UID：{{ scope.row.id }} · {{ scope.row.email }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="B站绑定" min-width="170">
          <template slot-scope="scope">
            <div>{{ scope.row.bilibili_uid || "未绑定" }}</div>
            <el-tooltip :content="scope.row.identity_code || '-'" placement="top">
              <div class="muted one-line">身份码：{{ scope.row.identity_code || "-" }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="角色" width="110">
          <template slot-scope="scope">
            <el-tag :type="scope.row.role === 'admin' ? 'danger' : 'info'">
              {{ scope.row.role === "admin" ? "管理员" : "普通用户" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="用户标签" width="130">
          <template slot-scope="scope">
            <span class="preview-tag" :style="tagStyle(scope.row)">{{ tagText(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="权限" min-width="220">
          <template slot-scope="scope">
            <el-tag size="mini" :type="Number(scope.row.can_private_chat) === 1 ? 'success' : 'info'">私聊</el-tag>
            <el-tag size="mini" :type="Number(scope.row.can_post) === 1 ? 'success' : 'info'">发帖</el-tag>
            <el-tag size="mini" :type="Number(scope.row.can_reply) === 1 ? 'success' : 'info'">回复</el-tag>
            <el-tag size="mini" :type="Number(scope.row.can_post_without_review) === 1 ? 'warning' : 'info'">免审</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="110">
          <template slot-scope="scope">
            <el-tag :type="statusType(scope.row.status)">{{ statusLabel(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="注册时间" width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.created_at) }}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openEdit(scope.row)">权限/封禁</el-button>
            <el-button type="text" size="small" @click="openNotice(scope.row)">发公告</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="用户权限与状态" :visible.sync="editVisible" width="520px">
      <el-form :model="editForm" label-width="120px">
        <el-form-item label="用户">
          <div>{{ editForm.nickname }}（UID：{{ editForm.id }}）</div>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="editForm.role" style="width: 100%">
            <el-option label="普通用户" value="user"></el-option>
            <el-option label="管理员" value="admin"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="私聊权限">
          <el-switch v-model="editForm.can_private_chat" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="发帖权限">
          <el-switch v-model="editForm.can_post" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="回复权限">
          <el-switch v-model="editForm.can_reply" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="发帖免审核">
          <el-switch v-model="editForm.can_post_without_review" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="用户标签">
          <el-input v-model="editForm.tag_text" maxlength="32" placeholder="星姬天 / 管理员 / 天选姬"></el-input>
        </el-form-item>
        <el-form-item label="标签文字色">
          <el-color-picker v-model="editForm.tag_text_color"></el-color-picker>
          <el-input v-model="editForm.tag_text_color" style="width: 140px; margin-left: 10px"></el-input>
        </el-form-item>
        <el-form-item label="标签背景色">
          <el-color-picker v-model="editForm.tag_bg_color"></el-color-picker>
          <el-input v-model="editForm.tag_bg_color" style="width: 140px; margin-left: 10px"></el-input>
        </el-form-item>
        <el-form-item label="标签预览">
          <span class="preview-tag" :style="tagStyle(editForm)">{{ tagText(editForm) }}</span>
        </el-form-item>
        <el-form-item label="账号状态">
          <el-select v-model="editForm.status" style="width: 100%">
            <el-option label="正常" value="normal"></el-option>
            <el-option label="封禁" value="banned"></el-option>
            <el-option label="停用" value="disabled"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="封禁原因" v-if="editForm.status === 'banned'">
          <el-input type="textarea" v-model="editForm.ban_reason" :rows="3" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="封禁到期" v-if="editForm.status === 'banned'">
          <el-date-picker
            v-model="editForm.ban_until"
            type="datetime"
            value-format="timestamp"
            placeholder="不填则按永久封禁处理"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" @click="saveUser">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="发送个人公告" :visible.sync="noticeVisible" width="520px">
      <el-form :model="noticeForm" label-width="90px">
        <el-form-item label="接收用户">
          <div>{{ noticeUser.nickname }}（UID：{{ noticeUser.id }}）</div>
        </el-form-item>
        <el-form-item label="公告标题">
          <el-input v-model="noticeForm.title" maxlength="255" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="公告类型">
          <el-input v-model="noticeForm.type" placeholder="admin / system / forum 等"></el-input>
        </el-form-item>
        <el-form-item label="公告内容">
          <el-input type="textarea" v-model="noticeForm.content" :rows="5"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="noticeVisible = false">取消</el-button>
        <el-button type="primary" @click="sendNotice">发送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { post } from "../axios/request.js";
import { formatTime, isSuccess, optionLabel, optionType, userStatusOptions } from "./appAdminUtils.js";

export default {
  name: "appUsers",
  data() {
    return {
      keyword: "",
      list: [],
      defaultAvatar: "https://tianxuanji.com/static/%E6%98%9F%E5%A7%AC%E5%A4%A9logo.webp",
      editVisible: false,
      editForm: {},
      noticeVisible: false,
      noticeUser: {},
      noticeForm: {
        title: "",
        content: "",
        type: "admin",
      },
    };
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    formatTime,
    statusLabel(value) {
      return optionLabel(userStatusOptions, value);
    },
    statusType(value) {
      return optionType(userStatusOptions, value);
    },
    tagText(row) {
      if (!row) return "星姬天";
      if (row.role === "admin" && (!row.tag_text || row.tag_text === "星姬天")) {
        return "管理员";
      }
      return row.tag_text || "星姬天";
    },
    tagStyle(row) {
      return {
        color: (row && row.tag_text_color) || "#ffffff",
        background: (row && row.tag_bg_color) || "#13E2CE",
      };
    },
    getUsers() {
      post("/api/admin/app/users", { keyword: this.keyword }).then((res) => {
        if (isSuccess(res)) {
          this.list = res.data.data || [];
        } else {
          this.$message.error(res.data.msg || "用户列表获取失败");
        }
      });
    },
    resetSearch() {
      this.keyword = "";
      this.getUsers();
    },
    openEdit(row) {
      this.editForm = {
        id: row.id,
        nickname: row.nickname || "",
        role: row.role || "user",
        can_private_chat: Number(row.can_private_chat) === 1 ? 1 : 0,
        can_post: Number(row.can_post) === 1 ? 1 : 0,
        can_reply: Number(row.can_reply) === 1 ? 1 : 0,
        can_post_without_review: Number(row.can_post_without_review) === 1 ? 1 : 0,
        tag_text: row.tag_text || (row.role === "admin" ? "管理员" : "星姬天"),
        tag_text_color: row.tag_text_color || "#ffffff",
        tag_bg_color: row.tag_bg_color || "#13E2CE",
        status: row.status || "normal",
        ban_reason: row.ban_reason || "",
        ban_until: row.ban_until ? Number(row.ban_until) * 1000 : "",
      };
      this.editVisible = true;
    },
    saveUser() {
      const payload = {
        uid: this.editForm.id,
        role: this.editForm.role,
        can_private_chat: this.editForm.can_private_chat,
        can_post: this.editForm.can_post,
        can_reply: this.editForm.can_reply,
        can_post_without_review: this.editForm.can_post_without_review,
        tag_text: this.editForm.tag_text || "星姬天",
        tag_text_color: this.editForm.tag_text_color || "#ffffff",
        tag_bg_color: this.editForm.tag_bg_color || "#13E2CE",
        status: this.editForm.status,
        ban_reason: this.editForm.status === "banned" ? this.editForm.ban_reason : "",
        ban_until: this.editForm.status === "banned" && this.editForm.ban_until ? Math.floor(Number(this.editForm.ban_until) / 1000) : 0,
      };
      post("/api/admin/app/updateuser", payload).then((res) => {
        if (isSuccess(res)) {
          this.$notify({ title: "保存成功", message: res.data.msg, type: "success" });
          this.editVisible = false;
          this.getUsers();
        } else {
          this.$message.error(res.data.msg || "保存失败");
        }
      });
    },
    openNotice(row) {
      this.noticeUser = row;
      this.noticeForm = {
        title: "",
        content: "",
        type: "admin",
      };
      this.noticeVisible = true;
    },
    sendNotice() {
      if (!this.noticeForm.title || !this.noticeForm.content) {
        this.$message.error("请填写公告标题和内容");
        return;
      }
      post("/api/admin/app/sendnotice", {
        uid: this.noticeUser.id,
        title: this.noticeForm.title,
        content: this.noticeForm.content,
        type: this.noticeForm.type || "admin",
      }).then((res) => {
        if (isSuccess(res)) {
          this.$notify({ title: "发送成功", message: res.data.msg, type: "success" });
          this.noticeVisible = false;
        } else {
          this.$message.error(res.data.msg || "发送失败");
        }
      });
    },
  },
};
</script>

<style scoped>
.app-admin-page {
  width: 100%;
  height: 100%;
  background: #f5f7fb;
  overflow: auto;
}
.app-admin-card {
  width: 98%;
  height: 95%;
  margin: 1.5% auto;
  padding: 22px;
  background: #fff;
  box-shadow: #e0e0e0 5px 5px 10px;
  box-sizing: border-box;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.toolbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.toolbar-count,
.muted {
  color: #7f8fa4;
  font-size: 12px;
}
.user-cell {
  display: flex;
  align-items: center;
}
.user-info {
  margin-left: 12px;
  overflow: hidden;
}
.nickname {
  font-weight: 600;
  color: #1f2d3d;
}
.one-line {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-tag {
  margin-right: 4px;
  margin-bottom: 4px;
}
.preview-tag {
  display: inline-block;
  min-width: 48px;
  height: 22px;
  line-height: 22px;
  padding: 0 9px;
  border-radius: 3px;
  font-size: 12px;
  text-align: center;
  box-sizing: border-box;
}
</style>
